import { Component, useEffect, useRef, type ReactNode } from "react";
import type { ChatComponent, DisplayCall, RenderResult } from "@rekonas/data-access";
import { SleepStageCard } from "./SleepStageCard";
import { HypnogramCard } from "./HypnogramCard";

interface Props {
  component: ChatComponent; recording: string; call?: DisplayCall; pending: boolean;
  onReport: (call: DisplayCall, error?: RenderResult["error"]) => void;
  onAcknowledge: (component: ChatComponent) => void; onAccessFailure: () => void;
  onDraftError?: (message: string) => void;
}
class DisplayBoundary extends Component<{ onFailure: () => void; fallback: string; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch() { this.props.onFailure(); }
  render() { return this.state.failed ? <aside className="sleep-card">{this.props.fallback}</aside> : this.props.children; }
}
function MountedCard(props: Props) {
  const reported = useRef(false);
  useEffect(() => {
    // Runs only after React commits a complete successful native render. A
    // failed render is handled by the boundary and never reports success.
    if (props.pending && props.call && !reported.current) {
      reported.current = true;
      props.onReport(props.call);
    }
  }, [props.pending, props.call, props.onReport]);
  const Card = props.component.payload?.type === "hypnogram" ? HypnogramCard : SleepStageCard;
  return <Card component={props.component} recording={props.recording} onDraftError={props.onDraftError} />;
}
export function DisplayToolCard(props: Props) {
  return <DisplayBoundary fallback={props.component.payload?.fallback || "Saved chart could not be displayed. Read the saved text answer."}
    onFailure={() => { if (props.pending && props.call) props.onReport(props.call, "render_failed"); }}>
    <MountedCard {...props} />
  </DisplayBoundary>;
}
